import { render } from "./QuestionTitle.vue?vue&type=template&id=14812707&scoped=true&ts=true"
import script from "./QuestionTitle.vue?vue&type=script&lang=ts"
export * from "./QuestionTitle.vue?vue&type=script&lang=ts"

import "./QuestionTitle.vue?vue&type=style&index=0&id=14812707&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14812707"]])

export default __exports__